import React, { useContext, useState } from 'react'
import { isMobile } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import { IOSSwitch } from '../../../Core/Buttons/IOSSwitch'
import { ReactComponent as MonthlySvg } from '../../../../assets/sidemenu/monthly.svg'
import { ReactComponent as YearlySvg } from '../../../../assets/sidemenu/annual.svg'
import { ReactComponent as RenewSvg } from '../../../../assets/renew.svg'
import './AutoRenewSection.css'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { InsuranceTypes } from '../../../../models/insurance-models/InsuranceBillingPeriodModel'
import {
    PolicyManagementContextStore,
    ACTIONS,
} from '../../../../context/PolicyManagementContext'
import { Action } from '../../../../models/Action'
import NewFillButton from '../../../Core/NewFillButton'
import { Dialog } from '@material-ui/core'
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame'
import { ElevatedCircle } from '../../../Core/ElevatedCircle'
import { awaitWithLoading } from '../../../../services/utils'
import policymanagementApi from '../../../../api/policymanagement.api'
import {
    EventEmitterService,
    EventKey,
} from '../../../../services/EventEmitterService'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../../services/FirebaseService'
import dayjs from 'dayjs'
import { AutoRenewTurnOffPopover } from '../../../Core/Popover/AutoRenewTurnOffPopover'

interface AutoRenewSectionProps {
    insurance: ActiveInsuranceModel;
}

export const AutoRenewSection = ({
    onModify,
    insurance,
    ...props
}: AutoRenewSectionProps) => {
    const policyManagementContext = useContext(PolicyManagementContextStore)
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)

    const toggleAutoRenew = async () => {
        let promise = insurance.autoRenew
            ? policymanagementApi.disableAutoRenew(insurance.insuranceId)
            : policymanagementApi.enableAutoRenew(insurance.insuranceId)
        let res = await awaitWithLoading(promise)
        closeConfirmationDialog()
        if (res.ok) {
            if (insurance.autoRenew){
                EventEmitterService.dispatch('OPEN_AUTO_RENEW_WINDOW')
            }

            policyManagementContext.dispatch(
                new Action(ACTIONS.TOGGLE_AUTO_RENEW, {
                    insuranceId: insurance.insuranceId,
                })
            )
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    const openConfirmationDialog = () => {
        if (insurance.autoRenew) setConfirmDialogOpen(true)
        else toggleAutoRenew()
    }

    const closeConfirmationDialog = () => {
        setConfirmDialogOpen(false)
    }

    return (
        <React.Fragment>
            {isMobile ? (
                <FlexView
                    vAlignContent={'center'}
                    className="full-width space-between"
                >
                    <div className="text-body black bold">
                        Auto renew {insurance.autoRenew ? 'on' : 'off'}
                    </div>
                    <IOSSwitch
                        onChange={openConfirmationDialog}
                        checked={insurance.autoRenew}
                    />
                </FlexView>
            ) : (
                <FlexView className="space-between" vAlignContent={'center'}>
                    <FlexView vAlignContent={'center'}>
                        {insurance.insuranceType == InsuranceTypes.ANNUAL ? (
                            <YearlySvg className="large-icon blue-svg-stroke" />
                        ) : (
                            <MonthlySvg className="large-icon blue-svg-stroke" />
                        )}
                        <div className="margin-left-12">
                            <div className="text-body bold black">
                                {insurance.insuranceType} Insurance
                            </div>
                            <div className="text-body black margin-top-6">
                                Auto renew: {insurance.autoRenew ? 'on' : 'off'}
                            </div>
                        </div>
                    </FlexView>
                    <IOSSwitch
                        onChange={openConfirmationDialog}
                        checked={insurance.autoRenew}
                    />
                </FlexView>
            )}
            <Dialog
                BackdropProps={{
                    style: { backgroundColor: 'white', opacity: 0.64 },
                }}
                fullWidth
                open={confirmDialogOpen}
                onClose={closeConfirmationDialog}
                PaperProps={{
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                    },
                }}
                maxWidth={'xs'}
            >
                <CircledPopUpFrame
                    onCancel={closeConfirmationDialog}
                    circleHeader={
                        <ElevatedCircle>
                            {' '}
                            <RenewSvg className="medium-icon blue-svg-path" />
                        </ElevatedCircle>
                    }
                >
                    <div className="text-body blue bold textcenter">
                        Are you sure you want to turn off your auto-renewal?
                    </div>
                    <br />
                    <div className="text-small black textcenter margin-top-basic">
                        You will not be covered after{' '}
                        {dayjs(insurance.insuranceEnd).format(
                            FirebaseService.getValue(
                                FirebaseConfigKey.LONG_DATE_FORMAT
                            )
                        )}
                    </div>
                    <br />
                    <FlexView
                        column={isMobile}
                        className="margin-top-basic space-between margin-bottom-basic"
                    >
                        {!isMobile && (
                            <NewFillButton
                                darkblue
                                onClick={closeConfirmationDialog}
                            >
                                No
                            </NewFillButton>
                        )}
                        <NewFillButton onClick={toggleAutoRenew}>
                            Yes
                        </NewFillButton>
                        {isMobile && (
                            <NewFillButton
                                darkblue
                                onClick={closeConfirmationDialog}
                            >
                                No
                            </NewFillButton>
                        )}
                    </FlexView>
                </CircledPopUpFrame>
            </Dialog>
            <AutoRenewTurnOffPopover insurance={insurance}/>
        </React.Fragment>
    )
}
